import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {LicenseSearchModel} from "../license-search.model";
import {LicenseEntityModel} from "../license-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-license-search-page",
    templateUrl: "./license-search-page.component.html",
    providers: [provideSearchModel(LicenseSearchModel), provideEntityModel(LicenseEntityModel)]
})
export class LicenseSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
